import React from 'react';
import PropTypes from 'prop-types';
import {find, kebabCase, map} from 'lodash';
import classnames from 'classnames';

// stylesheet
import styles from '../stylesheets/achievement-cards.module.scss';

export const AchievementCard = ({testid, onClick, identifier, label, selected, children}) => (
  <button
    className={classnames(styles.button, {[styles.selected]: selected})}
    type="button"
    aria-label={label}
    aria-live="assertive"
    onClick={onClick}
    data-segment-track="button"
    data-button-name={identifier}
    data-testid={testid}
  >
    {children}
  </button>
);

AchievementCard.propTypes = {
  testid: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  identifier: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default class AchievementCards extends React.Component {
  static propTypes = {
    userSelectedItems: PropTypes.array.isRequired,
    saveItem: PropTypes.func.isRequired,
    removeItem: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    trackPrefix: PropTypes.string.isRequired,
    size: PropTypes.string,
  };
  // 'size' is an arbitrary prop that i added for the undergraduate temperature check survey
  // currently the only value it can take is 'medium', because we wanted to make those
  // achievement cards show up as a 3x3 square.

  handleClick = (selected, data) => () => {
    if (selected) {
      this.props.removeItem({...data, _id: selected._id});
    } else {
      this.props.saveItem(data);
    }
  };

  render() {
    const {userSelectedItems, items, trackPrefix, size} = this.props;

    return (
      <div className={classnames(styles.container, {[styles[size]]: !!size})}>
        {map(items, (data, i) => {
          const {name, emoji, averageAwardAmount} = data;
          const selected = find(userSelectedItems, {name});
          const identifier = kebabCase(`${trackPrefix}-${name}`);
          const amountText = `$${averageAwardAmount}`;
          const label = selected ? `${amountText} Average Award Amount` : name;

          return (
            <AchievementCard
              key={`achievement-${i}`}
              label={label}
              aria-live="assertive"
              selected={selected}
              identifier={identifier}
              onClick={this.handleClick(selected, data)}
              testid={`achievement-card-${i}`}
            >
              <div className="achievement-step-emoji" aria-hidden>
                {emoji}
              </div>
              <span className={classnames('achievement-step-text', {selected})}>{name}</span>
              {averageAwardAmount && (
                <span className={classnames('achievement-step-award', {selected})}>
                  <p className="achievement-step-award-text">{amountText}</p>
                </span>
              )}
            </AchievementCard>
          );
        })}
      </div>
    );
  }
}
